import React from 'react'

const whiteList = {
  div: true,
  span: true,
  em: true,
  i: true,
  b: true,
  u: true,
  p: true,
  ol: true,
  ul: true,
  li: true,
}

const renderContent = (content, key) => {
  //console.log('typeof content', typeof content)
  if (!content) {
    return null
  }
  
  if (Array.isArray(content)) {
    return content.map((child, index) => renderContent(child, index))
  }
  
  if (typeof content === 'string') {
    return content
  }
  
  if (typeof content === 'object') {
    return render(content, key)
  }
}

const render = (content, key) => {
  const el = (whiteList[content.el] && content.el) || 'div'
  
  if (content.escape === false) {
    return React.createElement(el, {
      ...content.props,
      key: key,
      dangerouslySetInnerHTML: {
        __html: renderContent(content.content),
      },
    })
  } else {
    return React.createElement(el, {
      ...content.props,
      key: key,
    }, renderContent(content.content))
  }
}

export default renderContent


// WEBPACK FOOTER //
// ./src/utilities/renderContent.js